import type { ReactNode } from 'react';
import { SidebarProvider } from '@/contexts/SidebarContext';
import { AppSidebar } from './AppSidebar';
import { MobileTopBar } from './MobileTopBar';

interface AuthenticatedLayoutProps {
  children: ReactNode;
}

function AuthenticatedLayoutInner({ children }: AuthenticatedLayoutProps) {
  return (
    <div className="flex h-screen overflow-hidden">
      <AppSidebar />
      <div className="flex-1 flex flex-col min-w-0 relative">
        <MobileTopBar />
        <main className="flex-1 overflow-y-auto">{children}</main>
      </div>
    </div>
  );
}

export function AuthenticatedLayout({ children }: AuthenticatedLayoutProps) {
  return (
    <SidebarProvider>
      <AuthenticatedLayoutInner>{children}</AuthenticatedLayoutInner>
    </SidebarProvider>
  );
}
